// Apply a width and max width to keep the drawer from changing size too wildly
import { fromTheme } from '@kyruus/ui-theme';
import Button from '@kyruus/button';
import styled from '@emotion/styled';
import { AppDrawer } from '../../app-drawer/AppDrawer';
import { APP_DRAWER_WIDTH } from 'Src/app-drawer';

export const DBDrawerHeader = styled('header')`
  padding: ${fromTheme('spacing_small')};
  position: sticky;
  top: 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  column-gap: ${fromTheme('spacing_medium')};
  @media print {
    display: none;
    @page {
      margin: 0;
    }
  }
`;
export const ProviderInfoContainer = styled('div')`
  flex: 1;
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  row-gap: ${fromTheme('spacing_xsmall')};
  & > span {
    font-size: ${fromTheme('font_size')};
    color: ${fromTheme('color_text_secondary')};
  }
  & > span:first-of-type {
    font-size: ${fromTheme('font_size_heading_5')};
    color: ${fromTheme('color_text')};
  }
`;
export const DBDrawerCloseButton = styled(Button)`
  padding: ${fromTheme('spacing_small')};
  flex: 0;
  &:focus {
    background-color: inherit;
    border-color: ${fromTheme('color_border')};
  }
  &:hover {
    background-color: inherit;
    border-color: ${fromTheme('color_border')};
    color: ${fromTheme('color_item_hover')};
  }
  @media print {
    display: none;
  }
`;
export const DBDrawerCloseButtonWithDBHeader = styled(DBDrawerCloseButton)`
  position: fixed;
  top: 0px;
  right: 0px;
  z-index: 1000;
  margin: ${fromTheme('spacing_small')} ${fromTheme('spacing_medium')};
`;
// Ensure that the drawer content is scrollable (vertically)
export const DBDrawerContent = styled('div')`
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;

  & .DirectBook {
    & .MobileHeaderContent {
      padding: ${fromTheme('spacing_xsmall')};
    }

    & .BookButtonContainer {
      max-width: ${APP_DRAWER_WIDTH}px;
      left: inherit;
      right: 0px;
    }

    &
      .ProviderLocationsBody
      > ul.ProviderLocationsList
      > li
      > .BookableLocation {
      flex-flow: row-reverse;
      align-items: center;

      & > div {
        width: 100%;
      }
    }

    & li.GroupedAppt.GroupedAppt {
      flex: 0 1 100px;

      & > button {
        padding: ${fromTheme('spacing_small')};
      }
    }
  }
`;
const PROVIDER_IMAGE_MAX_HEIGHT = '40px';
const PROVIDER_IMAGE_MAX_WIDTH = '100%';
export const ProviderImageContainer = styled('img')`
  flex: 0;
  grid-area: image;
  display: block;
  max-width: ${PROVIDER_IMAGE_MAX_WIDTH};
  max-height: ${PROVIDER_IMAGE_MAX_HEIGHT};
  height: auto;
  width: auto;
  border-radius: ${fromTheme('border_radius')};

  @media only screen and (min-width: ${fromTheme('screen_medium')}) {
    max-width: 90px;
  }
`;

export const StyledAppDrawer = styled(AppDrawer)`
  & .MuiDrawer-paper {
    max-width: ${APP_DRAWER_WIDTH}px;
    width: 100%;
  }
`;
